import React, { useContext } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuthenticator } from "@aws-amplify/ui-react";
import { AppContext } from "../App";
import LiteDashboardScreen from "../pages/LiteDashboard";
import SearchPricelistScreen from "../pages/pricelists/SearchPricelist";
import ContactScreen from "../pages/Contact";
import SettingsScreen from "../pages/SettingsScreen";
import PricelistsMenuScreen from "../pages/pricelists/PricelistsMenu";
import PricelistGroupsScreen from "../pages/pricelists/PricelistGroups";
import CreatePricelistScreen from "../pages/pricelists/CreatePricelist";
import UploadPricelistScreen from "../pages/pricelists/UploadPricelist";
import AssignPricelistScreen from "../pages/pricelists/AssignPricelist";
import NewsScreen from "../pages/News";
import InvoicesScreen from "../components/invoices/Invoices";
import ViewInvoiceScreen from "../components/invoices/ViewInvoice";
import UsersScreen from "../pages/Users";
import UserGroupsScreen from "../pages/UserGroupManager";
import ViewPricelistsScreen from "../pages/ViewPricelists";
import EmailInviteScreen from "../pages/EmailInvite";
import ManagePricelistScreen from "../pages/pricelists/PricelistsMenu";
import SuperAdminUsersScreen from "../pages/SuperAdminUsers";
import PartDetailsScreen from "../pages/PartDetails";
import CreateInvoiceScreen from "../components/invoices/CreateInvoice";
import Notifications from "../pages/Notifications";
import ViewInvoicesScreen from "../components/invoices/ViewInvoices";
import AnalyticsScreen from "../pages/Analytics";
import EditInvoiceScreen from "../components/invoices/EditInvoice";
import Trending from "../pages/Trending";
import CatalystAI from "../pages/CatalystAI";
import BoxDetails from "../components/invoices/BoxDetails";
import MappedVINsUploadScreen from "../pages/MappedVINsUpload";
import VinSearchScreen from "../pages/VinSearch";
import PushPricelist from "../components/pricing/PushPricelist";
import SuperAdminOffsetSearch from "../pages/SuperAdminOffsetSearch";
import InnerPage from "./InnerPage";
// import ProviderList from '../pages/ProviderList';
// Import other screens as needed

const ProviderRoutes = () => {
  const { authStatus } = useAuthenticator((context) => [context.authStatus]);
  const { userRecord } = useContext(AppContext);

  if (authStatus !== "authenticated") {
    return <Navigate to="/login" replace />;
  }

  console.log("ProviderRoutes rendered");
  console.log("UserRecord in ProviderRoutes:", userRecord);

  return (
    <Routes>
      <Route
        path=""
        element={
          <Navigate to="/search-pricelist?defaultSearchMode=metals" replace />
        }
      />
      <Route path="search-pricelist" element={<SearchPricelistScreen />} />
      <Route path="vin-search" element={<VinSearchScreen />} />
      <Route path="contact" element={<ContactScreen />} />
      <Route path="settings" element={<SettingsScreen />} />
      <Route path="pricelists" element={<PricelistsMenuScreen />} />
      <Route path="pricelist-groups" element={<PricelistGroupsScreen />} />
      <Route path="create-pricelist" element={<CreatePricelistScreen />} />
      <Route path="upload-pricelist" element={<UploadPricelistScreen />} />
      <Route path="assign-pricelist" element={<AssignPricelistScreen />} />
      <Route path="news" element={<NewsScreen />} />
      <Route path="invoices" element={<InvoicesScreen />} />
      <Route path="create-invoice" element={<CreateInvoiceScreen />} />
      <Route path="invoices/new" element={<CreateInvoiceScreen />} />
      <Route
        path="view-invoice/:invoiceId"
        element={
          <InnerPage>
            <EditInvoiceScreen />
          </InnerPage>
        }
      />
      <Route
        path="view-invoice/:invoiceId/box/:boxId"
        element={<BoxDetails />}
      />
      <Route path="users" element={<UsersScreen />} />
      <Route path="user-group-manager" element={<UserGroupsScreen />} />
      <Route
        path="view-pricelists"
        element={<ViewPricelistsScreen user={userRecord} />}
      />
      <Route path="email-invite" element={<EmailInviteScreen />} />
      <Route path="manage-pricelists" element={<ManagePricelistScreen />} />
      <Route path="super-admin-users" element={<SuperAdminUsersScreen />} />
      <Route path="part-details" element={<PartDetailsScreen />} />
      <Route path="notifications" element={<Notifications />} />
      <Route
        path="view-invoices"
        element={
          <InnerPage>
            <ViewInvoicesScreen />
          </InnerPage>
        }
      />
      <Route path="analytics" element={<AnalyticsScreen />} />
      <Route path="alerts" element={<Notifications />} />
      <Route path="trending" element={<Trending />} />
      <Route path="catalyst-ai" element={<CatalystAI />} />
      <Route path="mapped-vins-upload" element={<MappedVINsUploadScreen />} />
      <Route path="push-pricelist" element={<PushPricelist />} />
      <Route
        path="super-admin-offset-search"
        element={<SuperAdminOffsetSearch />}
      />
      {/* Add other routes as needed */}
    </Routes>
  );
};

export default ProviderRoutes;
